function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M35.0704 41.3514H52V31.1827C51.8079 25.1859 35.0257 24.8326 35.0704 31.8051V41.3514Z",
  fill: "#FDFDFD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3175 13.3806C49.411 13.3806 49.3968 22.5119 43.3175 22.5119C37.2383 22.5119 37.2193 13.3806 43.3175 13.3806Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.5351,
  cy: 17.797,
  r: 4.6386,
  stroke: "black",
  strokeWidth: 2.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.0703 40.2473V32.1505C35.0703 28.8381 37.1313 26.6299 43.9032 26.6299C50.6751 26.6299 52 28.8381 52 32.1505V40.2473",
  stroke: "black",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.00009 41.2771H18.9297V31.1084C18.7376 25.1117 1.95541 24.7583 2.00009 31.7308V41.2771Z",
  fill: "#FDFDFD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2472 13.3063C16.3407 13.3063 16.3264 22.4376 10.2472 22.4376C4.16798 22.4376 4.14899 13.3063 10.2472 13.3063Z",
  fill: "#FDFDFD"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.4648,
  cy: 17.7227,
  r: 4.6386,
  stroke: "black",
  strokeWidth: 2.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M2 40.173V32.0762C2 28.7638 4.06101 26.5556 10.8329 26.5556C17.6048 26.5556 18.9297 28.7638 18.9297 32.0762V40.173",
  stroke: "black",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7218 45.8776H37.8839V33.1667C37.6437 25.6708 16.6659 25.2291 16.7218 33.9447V45.8776Z",
  fill: "#FDFDFD"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0305 10.914C34.6473 10.914 34.6295 22.3281 27.0305 22.3281C19.4314 22.3281 19.4077 10.914 27.0305 10.914Z",
  fill: "#FDFDFD"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 27.3031,
  cy: 16.4345,
  r: 5.86076,
  stroke: "black",
  strokeWidth: 3
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7217 44.4975V34.3764C16.7217 30.236 19.2979 27.4757 27.7628 27.4757C36.2277 27.4757 37.8839 30.236 37.8839 34.3764V44.4975",
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round"
});

function SvgConnections({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/connections.202c1c97079227f531b1defbac8ab416.svg";
export { ForwardRef as ReactComponent };